import { useDispatch, useSelector } from "react-redux";
import { setAccessAC, getAccessSettings } from "@entities";
import "./kh-access.scss";

import { Text, CheckBox } from "@ui-kit";

const KHAccess = () => {
  const dispatch = useDispatch();
  const access = useSelector(getAccessSettings);

  const defaultAccess = {
    "pm-t1-shutt": true,
    "pm-t1-adobe": false,
    "pm-t1-canva": false,

    "pm-t2-shutt": true,
    "pm-t2-adobe": false,
    "pm-t2-canva": true,

    "pm-t3-shutt": false,
    "pm-t3-adobe": false,
    "pm-t3-canva": false,

    "kh-t1-shutt": true,
    "kh-t1-adobe": false,
    "kh-t1-canva": true,

    "kh-t2-shutt": true,
    "kh-t2-adobe": false,
    "kh-t2-canva": true,

    "admin-shutt": true,
    "admin-adobe": true,
    "admin-canva": true,

    "user-shutt": false,
    "user-adobe": false,
    "user-canva": false,

    "myteamart-shutt": true,
    "myteamart-adobe": true,
    "myteamart-canva": true,

    "adobe-shutt": true,
    "adobe-adobe": true,
    "adobe-canva": false,
  };
  const effectiveAccess = { ...defaultAccess, ...access };

  // Функция для обновления конкретного чекбокса
  const onChange = (event, item) => {
    const newValue = event.target.checked;
    dispatch(setAccessAC({
      ...effectiveAccess,
      [item]: newValue,
    }));
  };

  return (
    <div className="kh-access">
      <div className="kh-access__header mb-24">
        <Text as="h5" className="subtitle mb-12">
          Access settings in the plugin for different groups.
        </Text>
      </div>

      <div className="kh-access__content">
        <div className="table">
          <div className="table-header">
            <div className="header__name">
              <Text as="h5">Name</Text>
            </div>
            <div className="header__subname">
              <Text as="h5">Sub Name</Text>
            </div>
            <div className="header__shutter">
              <Text as="h5">Shutter</Text>
            </div>
            <div className="header__adobe">
              <Text as="h5">Adobe</Text>
            </div>
            <div className="header__canva">
              <Text as="h5">Canva</Text>
            </div>
          </div>
          <div className="table__body">
            <div className="table__title">
              <div className="cell__name">
                <Text as="h5">Campaigns</Text>
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name">
                <Text as="h6">PatreonMax</Text>
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Делись и получай</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t1-shutt"] || false}
                  onChange={(event) => onChange(event, "pm-t1-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t1-adobe"] || false}
                  onChange={(event) => onChange(event, "pm-t1-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t1-canva"] || false}
                  onChange={(event) => onChange(event, "pm-t1-canva")}
                />
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Делись и получай + Canva</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t2-shutt"] || false}
                  onChange={(event) => onChange(event, "pm-t2-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t2-adobe"] || false}
                  onChange={(event) => onChange(event, "pm-t2-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t2-canva"] || false}
                  onChange={(event) => onChange(event, "pm-t2-canva")}
                />
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Free</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t3-shutt"] || false}
                  onChange={(event) => onChange(event, "pm-t3-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t3-adobe"] || false}
                  onChange={(event) => onChange(event, "pm-t3-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["pm-t3-canva"] || false}
                  onChange={(event) => onChange(event, "pm-t3-canva")}
                />
              </div>
            </div>

            <div className="table__row">
              <div className="cell__name">
                <Text as="h6">KeyHunter</Text>
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Key Hunter</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t1-shutt"] || false}
                  onChange={(event) => onChange(event, "kh-t1-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t1-adobe"] || false}
                  onChange={(event) => onChange(event, "kh-t1-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t1-canva"] || false}
                  onChange={(event) => onChange(event, "kh-t1-canva")}
                />
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Free (Trial)</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t2-shutt"] || false}
                  onChange={(event) => onChange(event, "kh-t2-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t2-adobe"] || false}
                  onChange={(event) => onChange(event, "kh-t2-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["kh-t2-canva"] || false}
                  onChange={(event) => onChange(event, "kh-t2-canva")}
                />
              </div>
            </div>

            <div className="table__title">
              <div className="cell__name">
                <Text as="h5">Roles</Text>
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name">
                <Text as="h6">Admin</Text>
              </div>
              <div className="cell__subname"></div>
              <div className="cell__shutter">
                <CheckBox
                  size="sm"
                  className="checkbox__item"
                  checked={effectiveAccess["admin-shutt"] || false}
                  onChange={(event) => onChange(event, "admin-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["admin-adobe"] || false}
                  onChange={(event) => onChange(event, "admin-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["admin-canva"] || false}
                  onChange={(event) => onChange(event, "admin-canva")}
                />
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name">
                <Text as="h6">User</Text>
              </div>
              <div className="cell__subname"></div>
              <div className="cell__shutter">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["user-shutt"] || false}
                  onChange={(event) => onChange(event, "user-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["user-adobe"] || false}
                  onChange={(event) => onChange(event, "user-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["user-canva"] || false}
                  onChange={(event) => onChange(event, "user-canva")}
                />
              </div>
            </div>
            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">MyteamArt</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["myteamart-shutt"] || false}
                  onChange={(event) => onChange(event, "myteamart-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["myteamart-adobe"] || false}
                  onChange={(event) => onChange(event, "myteamart-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["myteamart-canva"] || false}
                  onChange={(event) => onChange(event, "myteamart-canva")}
                />
              </div>
            </div>

            <div className="table__row">
              <div className="cell__name"></div>
              <div className="cell__subname">
                <Text as="h6">Adobe</Text>
              </div>
              <div className="cell__shutter">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["adobe-shutt"] || false}
                  onChange={(event) => onChange(event, "adobe-shutt")}
                />
              </div>
              <div className="cell__adobe">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["adobe-adobe"] || false}
                  onChange={(event) => onChange(event, "adobe-adobe")}
                />
              </div>
              <div className="cell__canva">
                <CheckBox
                  className="checkbox__item"
                  size="sm"
                  checked={effectiveAccess["adobe-canva"] || false}
                  onChange={(event) => onChange(event, "adobe-canva")}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KHAccess;
